import { ApiService } from './ApiService';
import { ResultOf } from '@/types/result';
import { AddCardFormModel } from '@/pages/Subscription/types/AddCardModel';
import { AddCardResponseModel } from '@/pages/Subscription/types/AddCardResponseModel';
type PaymentId = number;
export class PaymentsApi extends ApiService {
    base = 'Payments';
    async addCard(data: AddCardFormModel): Promise<ResultOf<AddCardResponseModel>> {
        return await this.post(this.getUrl('AddCard'), data);
    }
    async retryPayment(userId: number): Promise<ResultOf<PaymentId>> {
        return await this.get(this.getUrl('RetryPayment'), { userId });
    }
}
